import { ReactElement } from 'react'
import { Text, Textarea } from '../../Atoms'
import { TextInputSurroundedProps } from './props'
import { StyledTextInputSurrounded } from './styles'

const TextInputSurrounded = ({
    postFix,
    preFix,
    showText,
    ...props
}: TextInputSurroundedProps): ReactElement => {
    const inputComponent = (
        <Textarea {...props} data-testid="inputsurrounded" resize="none" />
    )

    return (
        <StyledTextInputSurrounded showText={showText}>
            {preFix && <Text>{preFix}</Text>}
            {inputComponent}
            {postFix && <Text>{postFix}</Text>}
        </StyledTextInputSurrounded>
    )
}

export default TextInputSurrounded
